'use client';

import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren } from 'react';
import { ApolloProvider, createApolloClient } from '@material-bank/graphql-client';
import { getAccessToken } from '@material-bank/mtag-authentication';
import { HapticsProvider } from '@material-bank/mtag-utilities';
import { env } from '../config/env';
const client = createApolloClient({
  uri: env.graphqlEndpoint,
  credentials: 'same-origin',
  getToken: getAccessToken
});
export function Providers(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <ApolloProvider client={client}><HapticsProvider>{children}</HapticsProvider></ApolloProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}